import {AfterViewInit, Component, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {Subject} from 'rxjs';
import {FlowChartDataService} from '../../../services/flow-chart-data.service';

@Component({
    standalone: false,
    selector: 'particle-submit-response-dialog',
  templateUrl: './submit-response-dialog.component.html',
  styleUrls: ['./submit-response-dialog.component.scss']
})
export class SubmitResponseDialogComponent implements OnInit, IDialogView, AfterViewInit {

  data: DialogModel;
  ngUnsubscribe = new Subject<void>();
  hasChange: boolean;
  constructor(private flowChartDataService: FlowChartDataService) {

  }

  ngOnInit() {
    console.log('Data in SubmitResponseDialogComponent', this.data.input);
    this.hasChange = this.data.input.newItemCount + this.data.input.updatedItemCount + this.data.input.discardedItemCount > 0;
  }
  ngAfterViewInit (): void {

  }
  onSelectStatusChange() {

  }
  onOkClicked(): boolean {
    this.data['dialogRef'].close();
    return this.hasChange;
  }

}
